import { SearchRequestModelFilterTypeEnum } from '@searchspring/snapi-types'
import type { SearchspringFilter } from '../types/searchspring'

export class UrlManager {
  static getFiltersFromUrl(
    searchParams: URLSearchParams,
  ): Record<string, string[]> {
    const filters: Record<string, string[]> = {}
    searchParams.forEach((_, key) => {
      if (key.startsWith('filter.')) {
        const field = key.replace('filter.', '')
        if (!filters[field]) {
          filters[field] = []
        }
        // Handle repeated params if standard URLSearchParams behavior
        // But since we iterate foreach, we catch all.
        // However, we want to ensure we don't duplicate logic if called differently.
        // Actually, URLSearchParams.getAll() is better if we knew the keys.
        // But since we don't know keys ahead of time, we iterate.
      }
    })

    // Re-iterate to respect getAll for specific keys if needed,
    // but the loop above already sees every entry.
    // 'value' is single string.

    // Let's do it cleaner
    const keys = Array.from(searchParams.keys()).filter((k) =>
      k.startsWith('filter.'),
    )
    const uniqueKeys = [...new Set(keys)]

    uniqueKeys.forEach((key) => {
      const field = key.replace('filter.', '')
      filters[field] = searchParams.getAll(key)
    })

    return filters
  }

  static convertToSearchspringFilters(
    filters: Record<string, string[]>,
  ): SearchspringFilter[] {
    const ssFilters: SearchspringFilter[] = []
    Object.entries(filters).forEach(([field, values]) => {
      values.forEach((value) => {
        ssFilters.push({
          type: 'value' as SearchRequestModelFilterTypeEnum,
          field: field,
          value: value,
        })
      })
    })
    return ssFilters
  }

  static getUrlForToggle(field: string, value: string): string {
    const url = new URL(window.location.href)
    const key = `filter.${field}`
    const currentValues = url.searchParams.getAll(key)

    // Remove all existing values for this key
    url.searchParams.delete(key)

    let newValues = [...currentValues]
    if (newValues.includes(value)) {
      newValues = newValues.filter((v) => v !== value)
    } else {
      newValues.push(value)
    }

    // Append updated values
    newValues.forEach((v) => url.searchParams.append(key, v))

    // Reset pagination on filter change
    url.searchParams.delete('page')

    return url.toString()
  }
}
